import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets.app/images/18518_hero_annual_exp_cancel_save_flow.svg'
import _imports_1 from '@/assets.app/images/18518_hero_monthly_exp_cancel_save_flow.svg'


const _hoisted_1 = { class: "cancel-flow-discount" }
const _hoisted_2 = {
  key: 0,
  class: "cancel-flow-discount__image",
  src: _imports_0,
  width: "335",
  height: "220",
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "cancel-flow-discount__image",
  src: _imports_1,
  width: "270",
  height: "247",
  alt: ""
}
const _hoisted_4 = { class: "cancel-flow-discount__heading" }
const _hoisted_5 = {
  key: 2,
  class: "cancel-flow-discount__subheading"
}
const _hoisted_6 = { class: "cancel-flow-discount__price" }
const _hoisted_7 = { class: "cancel-flow-discount__original" }
const _hoisted_8 = { class: "cancel-flow-discount__disclaimer" }
const _hoisted_9 = { class: "cancel-flow-popup__footer" }

import { computed, onMounted, ref } from 'vue'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import { Sentry } from '@/services/sentry'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelFlowDiscount',
  props: {
    billing: {}
  },
  emits: ["accepted", "decline"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const applying = ref(false)

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'discount')
  Mixpanel.trackCancelOfferShown(props.billing, null, 'discount')
})

const isAnnual = computed(() => props.billing.plan_id === 'plan_annual')

const heading = computed(() =>
  isAnnual.value
    ? 'Get 3 months free in your first year'
    : 'Get 50% off your first month',
)
const price = computed(() =>
  isAnnual.value ? 'For you $147.75/year' : 'Only $12/month',
)
const originalPrice = computed(() =>
  isAnnual.value ? 'Original price $197/year' : 'Original price $24/month',
)
const acceptLabel = computed(() =>
  isAnnual.value ? 'Get 3 bonus months' : 'Get 50% off',
)
const disclaimer = computed(() =>
  isAnnual.value
    ? 'Accepting this discount charges $147.75 today and extends your subscription for a year. After that, your subscription renews yearly at $197/year. Cancel anytime.'
    : 'Accepting this discount ends your trial and charges $12 for your first month. After that, your subscription renews monthly at $24/month. Cancel anytime.',
)

/**
 * Apply the discount registered on the intro step: it ends the trial and
 * charges the discounted amount.
 */
async function onAccept(): Promise<void> {
  Mixpanel.trackCancelFlowButtonClick(props.billing, 'discount', 'accept')
  try {
    applying.value = true
    await props.billing.applyCancelDiscount()
    Mixpanel.trackCancelOfferAccepted(props.billing, null, 'discount')
    emit('accepted')
  } catch (err) {
    Sentry.captureException(err)
    alert('Failed to apply the discount')
  } finally {
    applying.value = false
  }
}

// Declining continues to the reasons, it doesn't cancel the subscription.
function onDecline(): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'discount',
    'continue_canceling',
  )
  Mixpanel.trackCancelOfferDeclined(props.billing, null, 'discount')
  emit('decline')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (isAnnual.value)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_openBlock(), _createElementBlock("img", _hoisted_3)),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(heading.value), 1),
      (isAnnual.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Pay for 9 months - get 12 months "))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_6, _toDisplayString(price.value), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(originalPrice.value), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(disclaimer.value), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(AppButton, {
        loading: applying.value,
        disabled: applying.value,
        class: "cancel-flow-popup__cta",
        onClick: onAccept
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(acceptLabel.value), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"]),
      _createVNode(AppButton, {
        danger: true,
        disabled: applying.value,
        class: "cancel-flow-popup__cta",
        onClick: onDecline
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Continue Canceling ", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})